import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top whenever the pathname changes
    window.scrollTo(0, 0);
    
    // Alternative with smooth scroll (optional)
    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: 'instant' // or 'smooth' for animated scroll
    // });
  }, [pathname]);

  return null;
};

export default ScrollToTop;